import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import StickyWhatsApp from "@/components/StickyWhatsApp";
import Chatbot from "@/components/Chatbot";

import Home from "@/pages/Home";
import Services from "@/pages/Services";
import CaseExperience from "@/pages/CaseExperience";
import Blog from "@/pages/Blog";
import BlogDetail from "@/pages/BlogDetail";
import Booking from "@/pages/Booking";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

function ScrollTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function Shell({ children }) {
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith("/admin");
  return (
    <div className="App">
      <Navbar />
      {children}
      {!isAdmin && <Footer />}
      {!isAdmin && <StickyWhatsApp />}
      {!isAdmin && <Chatbot />}
    </div>
  );
}

function App() {
  return (
    <BrowserRouter>
      <ScrollTop />
      <Shell>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/services/:slug" element={<Services />} />
          <Route path="/cases" element={<CaseExperience />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogDetail />} />
          <Route path="/book" element={<Booking />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminDashboard />} />
        </Routes>
      </Shell>
      <Toaster richColors position="top-right" theme="dark" />
    </BrowserRouter>
  );
}

export default App;
